import dayjs from "dayjs";
import { Property, PropertyTypeEnum } from "graphql/generated/types";
import { SHORT_DATE } from "../../../../../../../utils/dates";

const formatters: {[key in PropertyTypeEnum]?: any }  = {
    date: (value: any) => dayjs(value).format(SHORT_DATE),
    checkbox: (value: any, translate: any) => value ? translate("Yes") : translate("No")
};

export const getPropertyValue = (item: any, property: Property, translate = (v: any) => v) => {
    if (!item || !item.properties) return undefined;
    const key = Object.keys(item.properties).find(key => key === property.uuid)!;
    let value = item.properties[key]?.value;
    if (value != null && formatters[property.type]) value = formatters[property.type](value, translate);
    return value;
};

export const mapProperties = (item: any, translate?: any) => (property: Property) =>
    ({ uuid: property.uuid, type: property.type, label: property.label, value: getPropertyValue(item, property, translate) });
